import type { AnySection, PresetSection } from '@wix/add-panel-common';
import { find } from 'ramda';
import { useEffect, useRef } from 'react';
import { useProcessed } from '../../utils/processPlaceholders';
import { FedopsInteraction } from '../../../constants/FedopsInteraction';
import { isPresetSection } from '../../../utils/entities/sections';
import { useActionsDispatcher } from '../../ActionsDispatcher';
import { useUtils } from '../../UtilsProvider';

export const useTrackFirstPresetSectionImageLoad = (sections: AnySection[]) => {
  const didTrack = useRef(false);
  const {
    media: { getMediaUrl },
  } = useUtils();
  const { dispatchFedopsInteractionEnded } = useActionsDispatcher();
  const firstPresetSection = find(isPresetSection, sections) as PresetSection;
  const imageSrc = useProcessed(firstPresetSection?.props.image && getMediaUrl(firstPresetSection.props.image));

  useEffect(() => {
    if (!imageSrc) {
      return;
    }
    const imageObject = new Image();
    imageObject.src = imageSrc;
    imageObject.onload = () => {
      if (didTrack.current === false) {
        didTrack.current = true;
        dispatchFedopsInteractionEnded({ interaction: FedopsInteraction.FirstPresetSectionLoad });
      }
    };
  }, [imageSrc, dispatchFedopsInteractionEnded]);
};
